import { createFileRoute, redirect } from '@tanstack/react-router'
import LoginComponent from '@/PageComponents/Login/LoginComponent'
import Storage from '@/utils/storage'
import * as Enums from '@/utils/enums'

type LoginSearch = {
  token_expired?: string
  message?: string
  mslc?: string
  otl?: string
  redirect?: string
  bypassLockout?: string
  // New SC Admin Login flow: pat = PlatformAuth access token, prt = refresh token.
  // Replaces the legacy mslc symmetric-encryption redirect minted by Manager MVC.
  pat?: string
  prt?: string
}

export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    token_expired: search.token_expired as string | undefined,
    message: search.message as string | undefined,
    mslc: search.mslc as string | undefined,
    otl: search.otl as string | undefined,
    redirect: search.redirect as string | undefined,
    bypassLockout: search.bypassLockout as string | undefined,
    pat: search.pat as string | undefined,
    prt: search.prt as string | undefined,
  }),
  beforeLoad: ({ search }) => {
    // Skip redirect for admin login (legacy mslc or new pat/prt), one-time login,
    // or explicit session-expiry flows. Without pat here, SC Admin Login silently
    // no-ops for an admin who already has a session in this browser.
    if (search.mslc || search.otl || search.token_expired || search.pat) return
    // Skip redirect when this tab was sent here because an admin logged in on another tab.
    // AuthProvider.tsx sets adminLogoutRedirect in sessionStorage before navigating here,
    // and auth.ts sets adminLoginLogout in localStorage before firing the logout event.
    if (typeof window !== 'undefined') {
      if (sessionStorage.getItem('adminLogoutRedirect') || localStorage.getItem('adminLoginLogout')) return
    }
    const token = Storage.getCookie(Enums.Cookie.token)
    if (token) {
      throw redirect({ to: search.redirect ?? '/' })
    }
  },
  component: LoginPage,
})

function LoginPage() {
  return <LoginComponent />
}
